<script lang="ts">
  import type { LeaderboardRank } from '$lib/api/types';
  import { auth } from '$lib/stores/auth.svelte';
  import { fade, fly } from 'svelte/transition';

  interface Props {
    leaderboard: LeaderboardRank[];
  }

  let { leaderboard }: Props = $props();
</script>

<div role="table" class="top10">
  <div class="list-header" role="row">
    <div class="list-header-rank" role="columnheader">Rank</div>
    <div class="list-header-student-name">Name</div>
    <div class="list-header-student-score">Score</div>
  </div>
  {#each leaderboard as leaderboardItem (leaderboardItem.studentId)}
    <div
      class="list-item"
      class:is-you={leaderboardItem.studentId === auth.user?.userId}
      role="row"
      class:border-top={leaderboardItem.rank > 10}
      in:fly|global={{ x: -200, delay: leaderboardItem.rank * 20 + 300 }}
      out:fade={{ duration: 100 }}
    >
      <div class="list-item-rank" role="rowheader">&num;{leaderboardItem.rank}</div>
      <div class="list-item-student-name" role="cell">
        {#if leaderboardItem.studentId === auth.user?.userId}
          You!
        {:else}
          {leaderboardItem.studentName}
        {/if}
      </div>
      <div class="list-item-student-score" role="cell">{leaderboardItem.score}</div>
    </div>
  {/each}
</div>

<style>
  .top10 {
    min-height: 400px;
  }

  .list-header {
    font-weight: bold;
    display: flex;
    border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color);
  }

  .list-item {
    display: flex;
  }

  .is-you {
    font-weight: bold;
  }

  .list-header > div,
  .list-item > div {
    padding: 0.5rem;
  }

  .list-header-rank,
  .list-item-rank {
    width: 4rem;
  }

  .list-item-rank {
    text-align: center;
    font-weight: bold;
  }

  .list-header-student-name,
  .list-item-student-name {
    flex-grow: 1;
  }

  .list-header-student-score,
  .list-item-student-score {
    width: 5rem;
    text-align: end;
  }
</style>
